import styled from 'styled-components';
import bgCardapio from '../../images/history_photo_02.jpg';



export const WrapperCulinaria = styled.div`
    display: flex;
    width: 100%;
    height: 100vh;
    flex-direction: column;
    align-items: center;
    background: #964F39;
    height: 100%;
    padding: 0 0 80px 0;

    background-image: url(${bgCardapio});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media screen and (max-width: 768px) {
        height: auto;
    }
`
export const TitleCulinaria = styled.h2`
    font-size: 1.8rem;
    color: white;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 20px;
    margin-top: 40px;
    overflow: hidden;
    opacity: 0;

`

export const TitleSeparador = styled.div`
    width: 15%;
    height: 9px;
    background: white;
    overflow-y: hidden;
    margin-bottom: 40px;
    opacity: 0;

    @media screen and (max-width: 768px) {
        width: 30%;
    }
    
        @media screen and (max-width: 425px) {
        width: 50%;
    }.   
`


export const WrapperItems = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 100%;
    justify-content: center;

    
    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        height: 100%;
        }
        `
export const ItemCulinaria = styled.div`
    background: rgba(255, 255, 255, 0.25); // mais translúcido
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 20px;
    border: 1.5px solid rgba(255, 255, 255, 0.35);    

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    width: 250px;
    max-width: 320px;
    min-height: 460px;  // ← Adicione esta linha
    max-height: auto;
    margin: 20px 20px;
    border: solid 2px #FFF;
    padding: 60px 10px;
    border-radius: 20px;
    transform: scale(1);
    transition: all 0.5s ease-out;

    &:hover {
        transition: all 1s ease-out;
        transform: scale(1.085);
    }

    @media screen and (max-width: 768px){
        width: 350px;
    }
`
export const Img = styled.img`
    width: 70%;
    height: auto;
    margin: -30px 0 40px 0;
`
export const TitleItem = styled.h3`
    color: white;
    display: flex;
    width: 100%;
    font-size: 1.2rem;
    margin-bottom: 40px;
    font-weight: normal;
    text-transform: uppercase;

`
export const TextItem = styled.p`
    display: flex;    
    color: white;
    font-family: 'Varela';
    font-weight: normal;
    font-size: 1rem;

`